import i18n from "../../../../../../i18n";
import { DTO_MobileProfile } from "../../../../../../services/calls/types/mobiles";

export type MobileInfo = {
  id: string
  label: string
  source: string
  path: string
  type?: string
  index?: number
}

enum DATA_ID {
  REGISTRY_NUMBER = 'registry_number',
  VEHICLE_STATUS = 'vehicle_status',
  TYPE = 'type',
  DESCRIPTION = 'description',
  FLEET_ACCESS = 'fleet_access',
  MILAGE = 'milage',
  INSURANCE_STATUS = 'insurance_status',
  INSPECTION_STATUS = 'inspection_status',
  LAST_INSPECTION = 'last_inspection',
  NEXT_INSPECTION = 'next_inspection',
  SENSOR_FRONT = 'sensor_front',
  SENSOR_BACK = 'sensor_back',
  PHOTO = 'photo'
}

const DATA: Record<string, MobileInfo> = {
  [DATA_ID.REGISTRY_NUMBER]: {
    id: DATA_ID.REGISTRY_NUMBER,
    label: i18n.t('Registry number'),
    source: 'automobile',
    path: 'registration_number'
  },
  [DATA_ID.VEHICLE_STATUS]: {
    id: DATA_ID.VEHICLE_STATUS,
    label: i18n.t('Vehicle status'),
    source: 'automobile',
    path: 'vehicle_status'
  },
  [DATA_ID.TYPE]: {
    id: DATA_ID.TYPE,
    label: i18n.t('Type'),
    source: 'automobile',
    path: 'mobile_type'
  },
  [DATA_ID.DESCRIPTION]: {
    id: DATA_ID.TYPE,
    label: i18n.t('Description'),
    source: 'automobile',
    path: 'description'
  },
  [DATA_ID.FLEET_ACCESS]: {
    id: DATA_ID.FLEET_ACCESS,
    label: i18n.t('Fleet access'),
    source: 'all_fleets',
    path: 'name'
  },
  [DATA_ID.MILAGE]: {
    id: DATA_ID.MILAGE,
    label: i18n.t('Milage'),
    source: 'data',
    path: 'get_odometer'
  },
  [DATA_ID.INSURANCE_STATUS]: {
    id: DATA_ID.INSURANCE_STATUS,
    label: i18n.t('Insurance status'),
    source: 'automobile',
    path: 'insured'
  },
  [DATA_ID.INSPECTION_STATUS]: {
    id: DATA_ID.INSPECTION_STATUS,
    label: i18n.t('Inspection status'),
    source: 'automobile',
    path: 'insured'
  },
  [DATA_ID.LAST_INSPECTION]: {
    id: DATA_ID.LAST_INSPECTION,
    label: i18n.t('Last inspection'),
    source: 'automobile',
    path: 'last_inspection',
    type: 'date'
  },
  [DATA_ID.NEXT_INSPECTION]: {
    id: DATA_ID.NEXT_INSPECTION,
    label: i18n.t('Next (planned) inspection'),
    source: 'automobile',
    path: 'next_planned_inspection',
    type: 'date'
  },
  [DATA_ID.SENSOR_FRONT]: {
    id: DATA_ID.SENSOR_FRONT,
    label: i18n.t('Front'),
    source: 'sensor',
    path: 'sensordata',
    type: 'temp',
    index: 0
  },
  [DATA_ID.SENSOR_BACK]: {
    id: DATA_ID.SENSOR_BACK,
    label: i18n.t('Back'),
    source: 'sensor',
    path: 'sensordata',
    type: 'temp',
    index: 1
  },
  [DATA_ID.PHOTO]: {
    id: DATA_ID.PHOTO,
    label: i18n.t('Vehicle picture'),
    source: 'automobile',
    path: 'picture',
    type: 'img'
  }
}

export const MOBILE_PROFILE_MAP = {
  MAIN: {
    label: null,
    data: [
      DATA[DATA_ID.REGISTRY_NUMBER], DATA[DATA_ID.VEHICLE_STATUS], DATA[DATA_ID.TYPE],
      DATA[DATA_ID.DESCRIPTION], DATA[DATA_ID.FLEET_ACCESS], DATA[DATA_ID.MILAGE],
      DATA[DATA_ID.INSURANCE_STATUS]
    ]
  },
  INSPECTION: {
    label: i18n.t('Inspection status'),
    data: [
      DATA[DATA_ID.INSPECTION_STATUS], DATA[DATA_ID.LAST_INSPECTION], DATA[DATA_ID.NEXT_INSPECTION]
    ]
  },
  TEMPERATURE: {
    label: i18n.t('Temperature'),
    visible: (data: DTO_MobileProfile) => data.sensor.length,
    data: [
      DATA[DATA_ID.SENSOR_FRONT], DATA[DATA_ID.SENSOR_BACK]
    ]
  },
  PICTURE: {
    label: null,
    data: [
      DATA[DATA_ID.PHOTO]
    ]
  }
}